import { useLazyQuery } from "@apollo/client"
import { ORDER_TYPES } from "data/orderTypes"
import { DELIVERY_METHODS } from "data/static.items"
import { useAllGroupsSelectorQuery } from "generated/graphql"
import { useOrderFilterVariables } from "graphql/dispatch/dispatch.hooks"
import { AGGREGATED_ORDER_ITEMS } from "graphql/order/order.queries.gql"
import useAuthorizationStrict from "hooks/useAuthorizationStrict"
import useSearchParams from "hooks/useSearchParams"
import { useEffect, useState } from "react"
import { useCurrentDc } from "store/auth.redux"
import { ApolloErrorToast } from "utils/AppToaster"
import BaseEncoder from "utils/base-encoder"

export const useAddOrder = () => {
  const [params] = useSearchParams()
  const orderStrings = params.ords
  const total = params.total

  const [distributionCenter] = useCurrentDc()
  const orderFilter = useOrderFilterVariables()
  const canSkipDmsFlow = useAuthorizationStrict(["vt_can_skip_dms_flow"])
  const { data } = useAllGroupsSelectorQuery()
  const [order, setOrder] = useState<any>({
    user: null,
    date: new Date(),
    orderItems: [
      {
        quantity: "",
      },
    ],
    pickupSlots: [{}],
    shippingMethod: DELIVERY_METHODS?.[0]?.id,
    skipDms: canSkipDmsFlow ? true : false,
  })

  const [getData] = useLazyQuery(AGGREGATED_ORDER_ITEMS, {
    onCompleted({ aggregatedOrderItems }) {
      setOrder(prev => ({
        ...prev,
        orderItems: aggregatedOrderItems,
      }))
    },
    onError: ApolloErrorToast,
  })

  const targetDcId = order?.targetDcId?.id

  useEffect(() => {
    const orders = BaseEncoder.decode(orderStrings)
      ?.split(",")
      .map(a => parseInt(a))
      .filter(a => a)

    if ((orders && orders.length > 0) || (total && total > 0)) {
      setOrder(prev => ({
        ...prev,
        orderCategory: ORDER_TYPES.filter(o => o.id === "T0")[0],
        group: data?.allGroups?.find(gr => gr?.name === "B2B Customer"),
      }))
    } else {
      setOrder(prev => ({
        ...prev,
        orderCategory: ORDER_TYPES.filter(o => o.id === "T2")[0],
        group: data?.allGroups?.find(gr => gr?.name === "B2B Customer"),
      }))
    }

    if (targetDcId && order?.orderCategory?.id !== "T2") {
      getData({
        variables: {
          orderIds: orders,
          targetDcId,
          orderingDcId: distributionCenter.id,
          filter: orderFilter,
        },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderStrings, getData, targetDcId, data])

  return [order, setOrder, distributionCenter] as const
}
